import { render, staticRenderFns } from "./style-group.vue?vue&type=template&id=a6c1f4c0&scoped=true&"
import script from "./style-group.vue?vue&type=script&lang=js&"
export * from "./style-group.vue?vue&type=script&lang=js&"
import style0 from "./style-group.vue?vue&type=style&index=0&id=a6c1f4c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c1f4c0",
  null
  
)

export default component.exports